import ErrorState from '@pinecast/common/ErrorState';
import LoadingState from '@pinecast/common/LoadingState';
import type {QueryResult} from '@pinecast/gql';
import type {RecurringDonationSupplemental} from '@pinecast/gql/__generated_tj__/RecurringDonationSupplemental';
import {FormattedMessage} from '@pinecast/i18n';

import ReceiptList from './ReceiptList';

type Props = {
  supplemental: QueryResult<RecurringDonationSupplemental>;
};

const RecurringDonationReceipts = ({supplemental}: Props) => {
  if (supplemental.loading) {
    return (
      <LoadingState
        title={
          <FormattedMessage
            description="Loading message for receipts for a podcast subscription"
            defaultMessage="Loading receipt info…"
          />
        }
      />
    );
  }
  if (supplemental.error) {
    return (
      <ErrorState
        title={
          <FormattedMessage
            description="Error message for receipts for a podcast subscription"
            defaultMessage="Could not load receipt information"
          />
        }
      />
    );
  }
  return <ReceiptList events={supplemental.data.tipJarSubscription!.events} />;
};

export default RecurringDonationReceipts;
